module.exports = __webpack_public_path__ + "static/media/fly0174.a3cb9299.webp";